/* eslint-disable */
import { Link } from "react-router-dom";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { assetImages } from "constants";

import * as url from "helper/UrlHelper";

import { getData } from "utils/Gateway";
import { getCurrentDateInString } from "helper/getcurrentdatestring";
import { createTaskChatHandler } from "helper/TaskHelper/TaskHelper";

import TaskPriority from "data/Prod/TaskPriority.json";
import TaskStatus from "data/Prod/TaskStatus.json";

const ColumnItem = (props) => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const { id, item, setReloadData, setSelectedComponentId, setSelectedTagId } =
    props;

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: 2,
    margin: 2,
    background: "#fff",
    //border: "1px solid #ccc"
  };

  // delete item
  const deleteComponentOrder = async (id) => {
    console.log("Delete Item: ", id);

    if (!window.confirm("Are you sure you want to delete this item?")) {
      return;
    }

    // set json data for each column ---------------------
    const columnItemsURL =
      url.API_BASE_URL +
      url.API_DELETE_COMPONENTORDER +
      `/${id}?token=${token}`;

    console.log("columnItemsURL", columnItemsURL);

    const response = await getData(columnItemsURL);

    console.log("deleteComponentOrderResponse", response);

    if (response.status) {
      setReloadData(true);
    }
  };

  const viewItemDetails = (itemid) => {
    // console.log("viewItemDetails for id", itemid);

    setSelectedComponentId(itemid);
    setSelectedTagId(null);
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <div
        className="card border border-gray-300 shadow-sm rounded-3 mb-2"
        style={{ backgroundColor: "#fdfdfd" }}
      >
        <div className="card-body p-3">
          {/* Header: Task ID and Actions */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center gap-2">
              {" "}
              <div
                className="cursor-pointer"
                onPointerDown={(e) => {
                  e.stopPropagation();
                  viewItemDetails(item.project._id);
                }}
              >
                <span className="badge bg-secondary-subtle text-dark border fw-semibold px-2 py-1">
                  # {item.project?.customid}
                </span>
              </div>
            </div>

            <div className="d-flex align-items-center gap-2">
              <Link
                to="#"
                className="btn btn-light btn-sm p-1 rounded-2 d-flex align-items-center justify-content-center"
                data-bs-toggle="offcanvas"
                data-bs-target="#viewTreatmentOffCanvas"
                aria-controls="viewTreatmentOffCanvas"
                onPointerDown={(e) => {
                  e.stopPropagation();
                  viewItemDetails(item.project._id);
                }}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "18px" }}
                >
                  visibility
                </span>
              </Link>
              <button
                type="button"
                className="btn btn-light btn-sm p-1 rounded-2 d-flex align-items-center justify-content-center"
                onPointerDown={(e) => {
                  e.stopPropagation();
                  deleteComponentOrder(item.id);
                }}
              >
                <span
                  className="material-symbols-outlined text-danger"
                  style={{ fontSize: "18px" }}
                >
                  delete
                </span>
              </button>
            </div>
          </div>

          {/* Task Title */}
          <h6
            className="fw-semibold mb-3"
            style={{ fontSize: "0.95rem", lineHeight: "1.3" }}
          >
            {item.project?.title}
          </h6>

          {/* Dates and Priority */}
          <div className="d-flex flex-wrap align-items-center gap-y-2 gap-x-3 mb-3 pb-2 border-bottom">
            <div className="d-flex align-items-center gap-1">
              <span
                className="material-symbols-outlined text-muted"
                style={{ fontSize: "16px" }}
              >
                calendar_month
              </span>
              <small className="text-muted">
                {getCurrentDateInString(item.project?.startdate, "dd/mm/yyyy")} - {getCurrentDateInString(item.project?.enddate, "dd/mm/yyyy")}
              </small>
            </div>
           
          </div>

          {/* Assigned User and Chat */}
          {item.project && item.project.medicalextension && item.project.medicalextension.patient && (
            <div className="d-flex align-items-center gap-2 mb-3">
              {/* role badge */}
              <span className="badge bg-info-subtle text-dark border fw-semibold px-2 py-1">
                Patient
              </span>
              {/* avatar */}
              <div
                className="rounded-circle overflow-hidden"
                style={{ width: "26px", height: "26px" }}
              >
                <img
                  src={
                    item.project?.medicalextension?.patient?.imagepath === ""
                      ? assetImages.defaultUser
                      : url.SERVER_URL + item.project.medicalextension.patient.imagepath
                  }
                  alt={item.project.medicalextension.patient.imagepath}
                  className="w-100 h-100 object-fit-cover"
                />
              </div>
              {/* name */}
              <span className="fs-sm text-body-secondary">
                {item.project.medicalextension.patient?.name} {item.project.medicalextension.patient?.surname}
              </span>
              {(item.project.medicalextension.patient._id !== userInfo._id) && (
                <button
                  className="btn btn-light btn-sm p-1 d-flex align-items-center justify-content-center"
                >
                  <span className="material-symbols-outlined text-primary" style={{ fontSize: "16px" }}>
                    chat
                  </span>
                </button>
              )}
            </div>
          )}
          {/* Assigned doctor and chat */}
          {item.project && item.project.medicalextension && item.project.medicalextension.doctor && (
            <div className="d-flex align-items-center gap-2 mb-3">
              {/* role badge */}
              <span className="badge bg-warning-subtle text-dark border fw-semibold px-2 py-1">
                Doctor
              </span>
              {/* avatar */}
              <div
                className="rounded-circle overflow-hidden"
                style={{ width: "26px", height: "26px" }}
              >
                <img
                  src={
                    item.project?.medicalextension?.doctor?.imagepath === ""
                      ? assetImages.defaultUser
                      : url.SERVER_URL + item.project.medicalextension.doctor.imagepath
                  }
                  alt={item.project.medicalextension.doctor.imagepath}
                  className="w-100 h-100 object-fit-cover"
                />
              </div>
              {/* name */}
              <span className="fs-sm text-body-secondary">
                {item.project.medicalextension.doctor?.name} {item.project.medicalextension.doctor?.surname}
              </span>
              {(item.project.medicalextension.doctor._id !== userInfo._id) && (
                <button
                  className="btn btn-light btn-sm p-1 d-flex align-items-center justify-content-center"
                >
                  <span className="material-symbols-outlined text-primary" style={{ fontSize: "16px" }}>
                    chat
                  </span>
                </button>
              )}
            </div>
          )}
          

          {/* Footer: Status and Rank */}

          <div className="d-flex align-items-center gap-3">

            {/* Progress percent */}
            <div className="d-flex align-items-center gap-1">
              <small className="text-muted fw-medium">
                Progress: {item.project?.progress ?? 0}%
              </small>
            </div>{" "}

            {/* status of the treatment */}
            <span className="badge bg-primary text-white px-2 py-1">
              {item.project?.medicalextension?.treatmentstatus}
            </span>
            {/* last modified */
            <div className="d-flex align-items-center gap-1 ms-auto">
              <span
                className="material-symbols-outlined text-muted"
                style={{ fontSize: "16px" }}
              >
                update
              </span>
              <small className="text-muted fw-medium">
                {getCurrentDateInString(item.project?.updatedAt, "dd/mm/yyyy")}
              </small>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColumnItem;
